import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/laboratorio';
import LaboratoriosLatexList from './LaboratoriosList';

const ms2p = (state) => {
  return {
    ...state.laboratorio,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(LaboratoriosLatexList);
